import React from 'react'
import CourierTable from './CourierTable';

const CourierManagement = () => {
  return (
    <div className=" flex flex-col gap-6 p-4  sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Courier Management</h1>
      </div>
      <CourierTable />
    </div>
  );
}

export default CourierManagement